import React, { useState } from "react";
import {
  HStack,
  Box,
  Stack,
  FormControl,
  FormLabel,
  Select,
  Input,
  Button,
  Switch,
  useToast,
  FormErrorMessage,
} from "@chakra-ui/react";
import { Field } from "formik";
import { MdArrowDropDown, MdNavigateNext } from "react-icons/md";
import { handleUsuarioIT } from "../../../../../utils/UsuarioIT";
import {
  validateEtapasNumber,
  validateOnSubmit,
} from "../../../../../utils/Validaciones";
import "../../../../../styles/PrimerPasoEtapa.css"; // Assuming you have a CSS file for styles
import useTiposOperaciones from "../../../../../hooks/useTiposOperaciones";
import { CONSTANTS } from "../../../../../utils/dictionary";

const PrimerPasoEtapa = (props) => {
  const [loading, setLoading] = useState(false);
  const { tipoOperaciones } = useTiposOperaciones({ setLoading });
  const toast = useToast();
  const {
    planificacion,
    etapasDatos,
    handleBlur,
    handleChange,
    values,
    setFieldValue,
    activeStep,
    setActiveStep,
    usuarios,
    setFormValues,
    user,
    touched,
    errors,
    type,
  } = props;
  const [numPozoEtapaSC, setNumPozoEtapaSC] = useState([]);
  const [numEtapaEditar] = useState(
    type === "editar" ? values.numTotalEtapaSC : null
  );
  // Guardar el valor original de numPozoEtapaSC al montar el componente en modo editar
  const [numPozoEtapaOriginal] = useState(
    type === "editar" ? values.numPozoEtapaSC : null
  );
  // const [maxNumPozoEtapaSC, setMaxNumPozoEtapaSC] = useState(1);
  // const maxNumTotalEtapaSC = etapasDatos.maxNumTotalEtapaSC + 1;
  const etapasPlanificacionList =
    type === "editar"
      ? planificacion.etapasSC
          ?.map((e) => e.numTotalEtapaSC)
          .filter((e) => e.eliminado === false && e !== numEtapaEditar)
      : planificacion.etapasSC
          ?.filter((e) => e.eliminado === false)
          ?.map((e) => e.numTotalEtapaSC);

  // Inicializar numPozoEtapaSC cuando el componente monta en modo editar
  React.useEffect(() => {
    if (
      type === "editar" &&
      values.idPozoEtapa &&
      etapasDatos.pozos?.length > 0
    ) {
      const etapasPozo = etapasDatos.pozos.find(
        (e) => e.nombrePozo === values.idPozoEtapa
      );
      if (etapasPozo?.detalle?.length > 0) {
        const numPozoEtapasList = etapasPozo.detalle
          .map((e) => e.numPozoEtapaSC)
          .filter((e) => e !== numPozoEtapaOriginal);
        setNumPozoEtapaSC(numPozoEtapasList);
      }
    }
  }, [type, values.idPozoEtapa, etapasDatos.pozos, numPozoEtapaOriginal]);

  // Función para manejar input de solo números enteros positivos
  const handleIntegerInput = (e, fieldName) => {
    const value = e.target.value;

    // Si el campo está vacío, establecer como cadena vacía (no NaN)
    if (value === "") {
      setFieldValue(fieldName, "");
      return;
    }

    // Permitir solo números enteros positivos (incluyendo 0)
    // Regex: acepta 0 solo o números que empiezan con 1-9 seguidos de cualquier dígito
    if (/^(0|[1-9]\d*)$/.test(value)) {
      // Convertir a número para almacenar como number
      const numValue = parseInt(value, 10);
      setFieldValue(fieldName, numValue);
    }
    // Si el usuario intenta ingresar caracteres no permitidos, no hace nada (mantiene el valor anterior)
  };

  const handleEtapaPozo = (idPozoEtapa, setFieldValue) => {
    if (!idPozoEtapa) {
      setFieldValue("idPozoEtapa", "");
      setFieldValue("numPozoEtapaSC", "");
      setNumPozoEtapaSC([]);
      return;
    }
    let etapasPozo;
    if (etapasDatos?.pozos?.length > 0) {
      etapasPozo = etapasDatos.pozos?.find((e) => e.nombrePozo === idPozoEtapa);
    }

    if (etapasPozo?.detalle?.length > 0) {
      // En modo editar, usar el valor original para filtrar, no el valor actual de values
      const numPozoEtapaSC =
        type === "editar"
          ? etapasPozo.detalle
              ?.map((e) => e.numPozoEtapaSC)
              .filter((e) => e !== numPozoEtapaOriginal) // Usar el valor original guardado
          : etapasPozo.detalle?.map((e) => e.numPozoEtapaSC);
      const maxNumPozoEtapaSC = Math.max(...numPozoEtapaSC) + 1;
      setNumPozoEtapaSC(numPozoEtapaSC);
      // setMaxNumPozoEtapaSC(maxNumPozoEtapaSC);
      setFieldValue("numPozoEtapaSC", maxNumPozoEtapaSC);
      setFieldValue("idPozoEtapa", idPozoEtapa);
    } else {
      setNumPozoEtapaSC([]);
      setFieldValue("numPozoEtapaSC", 1);
      setFieldValue("idPozoEtapa", idPozoEtapa);
    }
  };

  const handleAvanzar = () => {
    setLoading(true);
    if (!values.idPozoEtapa) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "ID de pozo requerido",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } else if (
      !values.numPozoEtapaSC ||
      validateOnSubmit("number", values.numPozoEtapaSC)
    ) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Número de etapa por pozo esta vacio o es incorrecto",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } else if (
      !values.numTotalEtapaSC ||
      validateOnSubmit("number", values.numTotalEtapaSC)
    ) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Número de etapa total esta vacio o es incorrecto",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } else if (!values.fechaInicioEtapaSC) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Fecha inicial requerido",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } else if (!values.idTipoOperacion) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Tipo de operación requerido",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } else if (!values.supervisor) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Supervisor requerido",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } else if (!values.operador1) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Operadores requeridos",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } else if (
      Number(values.idTipoOperacion) !== CONSTANTS.TIPO_OPERACION.A_GRANEL.ID &&
      !values.maquinista
    ) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Maquinista requerido",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } else if (
      Number(values.idTipoOperacion) !== CONSTANTS.TIPO_OPERACION.A_GRANEL.ID &&
      !values.idSander
    ) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Sander requerido",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } else if (
      Number(values.idTipoOperacion) !== CONSTANTS.TIPO_OPERACION.A_GRANEL.ID &&
      !values.idAutoE
    ) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Autoelevador requerido",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } else if (errors.numPozoEtapaSC) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Errores en número de etapa por pozo",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } else if (errors.numTotalEtapaSC) {
      setLoading(false);
      return toast({
        title: "Error",
        description: "Errores en número de etapa total",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    } else {
      setFormValues({
        initialValues: {
          ...values,
          idPozoEtapa: values.idPozoEtapa,
          fechaInicioEtapaSC: values.fechaInicioEtapaSC,
          fechaFinalEtapaSC: values.fechaFinalEtapaSC,
          numPozoEtapaSC: values.numPozoEtapaSC,
          numTotalEtapaSC: values.numTotalEtapaSC,
          supervisor: values.supervisor,
          operador1: values.operador1,
          operador2: values.operador2,
          maquinista: values.maquinista,
          idSander: values.idSander,
          idAutoE: values.idAutoE,
          etapaWeTSanD: values.etapaWeTSanD,
          limpieza: values.limpieza,
          idTipoOperacion: Number(values.idTipoOperacion),
        },
      });
      const nextStep =
        Number(values.idTipoOperacion) !== CONSTANTS.TIPO_OPERACION.A_GRANEL.ID
          ? activeStep + 1
          : activeStep + 3;
      setActiveStep(nextStep);
    }
  };

  return (
    <Stack>
      <HStack className="formHLine">
        <FormControl w="xs" isRequired placeSelf={"start"}>
          <FormLabel fontWeight="semibold">ID Pozo</FormLabel>
          <Select
            placeholder="Seleccione pozo"
            icon={<MdArrowDropDown />}
            w="2xs"
            type="text"
            name="idPozoEtapa"
            onBlur={handleBlur}
            onChange={(e) => handleEtapaPozo(e.target.value, setFieldValue)}
            value={values.idPozoEtapa}
          >
            {planificacion.pozos?.map((pozo) => (
              <option key={pozo.idPozo} value={pozo.nombrePozo}>
                {pozo.nombrePozo}
              </option>
            ))}
          </Select>
        </FormControl>
        <Stack placeSelf={"start"}>
          <Field
            name="numPozoEtapaSC"
            validate={(value) => {
              const error = validateEtapasNumber({
                value,
                name: "Nro. Etapa pozo",
                isLimpieza: values.limpieza,
                // maxNumPozoEtapaSC,
                numPozoEtapaSC,
              });
              return !values.limpieza && error;
            }}
          >
            {({ field }) => (
              <FormControl
                isInvalid={errors.numPozoEtapaSC && touched.numPozoEtapaSC}
                w={"xs"}
                isRequired
              >
                <FormLabel fontWeight="semibold">Nro. Etapa (pozo)</FormLabel>
                <Input
                  {...field}
                  w="2xs"
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  name="numPozoEtapaSC"
                  onBlur={handleBlur}
                  onChange={(e) => handleIntegerInput(e, "numPozoEtapaSC")}
                  value={
                    !values.limpieza
                      ? values.numPozoEtapaSC === ""
                        ? ""
                        : values.numPozoEtapaSC
                      : 0
                  }
                  onKeyDown={(e) => {
                    // Prevenir teclas no numéricas y algunos caracteres especiales
                    if (
                      e.key === "." ||
                      e.key === "," ||
                      e.key === "-" ||
                      e.key === "+" ||
                      e.key === "e" ||
                      e.key === "E"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  isDisabled={values.limpieza}
                />
                <FormErrorMessage>{errors.numPozoEtapaSC}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </Stack>
        <Stack placeSelf={"start"}>
          <Field
            name="numTotalEtapaSC"
            validate={(value) => {
              const error = validateEtapasNumber({
                value,
                name: "Nro. Etapa Total",
                isLimpieza: values.limpieza,
                // maxNumTotalEtapaSC,
                etapasPlanificacionList,
              });
              return !values.limpieza && error;
            }}
          >
            {({ field }) => (
              <FormControl
                isInvalid={errors.numTotalEtapaSC && touched.numTotalEtapaSC}
                w={"xs"}
                isRequired
              >
                <FormLabel fontWeight="semibold">Nro. Etapa (total)</FormLabel>
                <Input
                  {...field}
                  w="2xs"
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  name="numTotalEtapaSC"
                  onBlur={handleBlur}
                  onChange={(e) => handleIntegerInput(e, "numTotalEtapaSC")}
                  value={
                    !values.limpieza
                      ? values.numTotalEtapaSC === ""
                        ? ""
                        : values.numTotalEtapaSC
                      : 0
                  }
                  onKeyDown={(e) => {
                    // Prevenir teclas no numéricas y algunos caracteres especiales
                    if (
                      e.key === "." ||
                      e.key === "," ||
                      e.key === "-" ||
                      e.key === "+" ||
                      e.key === "e" ||
                      e.key === "E"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  isDisabled={values.limpieza}
                />
                <FormErrorMessage>{errors.numTotalEtapaSC}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </Stack>
      </HStack>
      <HStack className="formHLine">
        <FormControl w="xs">
          <FormLabel fontWeight="semibold">Fecha y Hora de Inicio</FormLabel>
          <Input
            w="2xs"
            type="datetime-local"
            name="fechaInicioEtapaSC"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.fechaInicioEtapaSC}
          />
        </FormControl>
        <FormControl w="xs" isRequired>
          <FormLabel fontWeight="semibold">Tipo de Operación</FormLabel>
          <Select
            w="2xs"
            placeholder="Seleccionar tipo de operación"
            name="idTipoOperacion"
            onChange={(e) =>
              setFieldValue("idTipoOperacion", Number(e.target.value))
            }
            onBlur={handleBlur}
            value={Number(values?.idTipoOperacion) || ""}
          >
            {tipoOperaciones?.map((element) => (
              <option key={element.id} value={element.id}>
                {element.descripcion}
              </option>
            ))}
          </Select>
        </FormControl>
        <HStack w="xs" justifyContent="space-between">
          <FormControl w="xs">
            {planificacion.dosificadora && (
              <>
                <FormLabel fontWeight="semibold">Wetsand</FormLabel>
                <HStack spacing={5}>
                  <Switch
                    onChange={handleChange}
                    isChecked={values.etapaWeTSanD}
                    name="etapaWeTSanD"
                    size={"lg"}
                  />
                </HStack>
              </>
            )}
          </FormControl>
          <FormControl w="xs">
            <FormLabel fontWeight="semibold">Etapa limpieza</FormLabel>
            <HStack spacing={5}>
              <Switch
                onChange={handleChange}
                onBlur={handleBlur}
                isChecked={values.limpieza}
                name="limpieza"
                size={"lg"}
              />
            </HStack>
          </FormControl>
        </HStack>
      </HStack>
      <HStack className="formHLine">
        <FormControl w="xs" isRequired>
          <FormLabel fontWeight="semibold">Supervisor</FormLabel>
          <Select
            placeholder="Seleccione supervisor"
            icon={<MdArrowDropDown />}
            w="2xs"
            type="text"
            name="supervisor"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.supervisor}
          >
            {usuarios
              .filter((e) => e.puesto === "supervisor")
              .sort((a, b) => {
                // Ordenar alfabéticamente por nombre y apellido
                const nameA = `${a.nombre}`.toUpperCase();
                const nameB = `${b.nombre}`.toUpperCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
              })
              .map((user) => (
                <option key={user.idUsuario} value={user.nombre}>
                  {user.nombre}
                </option>
              ))}
          </Select>
        </FormControl>
        <FormControl w="xs" isRequired>
          <FormLabel fontWeight="semibold">Operador</FormLabel>
          <Select
            placeholder="Seleccione operador"
            icon={<MdArrowDropDown />}
            w="2xs"
            type="text"
            name="operador1"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.operador1}
          >
            {usuarios
              .filter((e) => e.puesto === "operador")
              .sort((a, b) => {
                // Ordenar alfabéticamente por nombre y apellido
                const nameA = `${a.nombre}`.toUpperCase();
                const nameB = `${b.nombre}`.toUpperCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
              })
              .map((user) => (
                <option key={user.idUsuario} value={user.nombre}>
                  {user.nombre}
                </option>
              ))}
          </Select>
        </FormControl>
        <FormControl w="xs">
          <FormLabel fontWeight="semibold">Operador</FormLabel>
          <Select
            placeholder="Seleccione operador"
            icon={<MdArrowDropDown />}
            w="2xs"
            type="text"
            name="operador2"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.operador2}
          >
            {usuarios
              .filter((e) => e.puesto === "operador")
              .filter((e) => e.username !== values.operador1)
              .sort((a, b) => {
                // Ordenar alfabéticamente por nombre y apellido
                const nameA = `${a.nombre}`.toUpperCase();
                const nameB = `${b.nombre}`.toUpperCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
              })
              .map((user) => (
                <option key={user.idUsuario} value={user.nombre}>
                  {user.nombre}
                </option>
              ))}
          </Select>
        </FormControl>
      </HStack>
      <HStack className="formHLine">
        <FormControl
          w="xs"
          isRequired={
            values.idTipoOperacion != CONSTANTS.TIPO_OPERACION.A_GRANEL.ID
          }
        >
          <FormLabel fontWeight="semibold">Maquinista</FormLabel>
          <Select
            placeholder="Seleccione maquinista"
            icon={<MdArrowDropDown />}
            w="2xs"
            type="text"
            name="maquinista"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.maquinista}
          >
            {usuarios
              .filter(
                (e) => e.puesto === "maquinista" || e.puesto === "operador"
              )
              .sort((a, b) => {
                // Ordenar alfabéticamente por nombre y apellido
                const nameA = `${a.nombre}`.toUpperCase();
                const nameB = `${b.nombre}`.toUpperCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
              })
              .map((user) => (
                <option key={user.idUsuario} value={user.nombre}>
                  {user.nombre}
                </option>
              ))}
          </Select>
        </FormControl>
        <FormControl
          w="xs"
          isRequired={
            values.idTipoOperacion != CONSTANTS.TIPO_OPERACION.A_GRANEL.ID
          }
        >
          <FormLabel fontWeight="semibold">Sander</FormLabel>
          <Select
            placeholder="Seleccione sander"
            icon={<MdArrowDropDown />}
            w="2xs"
            type="text"
            name="idSander"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.idSander}
          >
            {planificacion.sanderPrincipal && (
              <option value={planificacion.sanderPrincipal.idSander}>
                {planificacion.sanderPrincipal?.codigoSander}
              </option>
            )}
            {planificacion.sanderBackup && (
              <option value={planificacion.sanderBackup.idSander}>
                {planificacion.sanderBackup.codigoSander}
              </option>
            )}
          </Select>
        </FormControl>
        <FormControl
          w="xs"
          isRequired={
            values.idTipoOperacion != CONSTANTS.TIPO_OPERACION.A_GRANEL.ID
          }
        >
          <FormLabel fontWeight="semibold">Autoelevador</FormLabel>
          <Select
            placeholder="Seleccione autoelevador"
            icon={<MdArrowDropDown />}
            w="2xs"
            type="text"
            name="idAutoE"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.idAutoE}
          >
            {planificacion.autoelevador1 && (
              <option value={planificacion.autoelevador1.idAutoE}>
                {planificacion.autoelevador1.nombreAutoE}
              </option>
            )}
            {planificacion.autoelevador2 && (
              <option value={planificacion.autoelevador2.idAutoE}>
                {planificacion.autoelevador2.nombreAutoE}
              </option>
            )}
          </Select>
        </FormControl>
      </HStack>
      <Box placeSelf="end" px={5}>
        <Button
          fontSize={12}
          fontWeight="semibold"
          bg="brand.naranja"
          color="white"
          rightIcon={<MdNavigateNext fontSize="20px" />}
          variant="solid"
          form="FormularioEtapa"
          onClick={() =>
            user.idRol === "usuarioIT"
              ? handleUsuarioIT(setActiveStep, activeStep)
              : handleAvanzar()
          }
          isDisabled={loading}
          _hover={{ bg: "white", color: "brand.naranja" }}
        >
          Continuar
        </Button>
      </Box>
    </Stack>
  );
};

export default PrimerPasoEtapa;
